<template>
  <div>
    <!-- 新增帖文按鈕 -->
    <div class="section-group div-btn-flex">
      <button type="button" class="btn btn-block btn-primary btn-fixed" data-hover="Click me!" data-toggle="modal"
        @click="add">
        <i class="fa fa-plus fa-fw fa-sm mr-1" aria-hidden="true"></i><i></i>
         {{ $t('Social.CreateFeed.Newpost') }}
      </button>
    </div>
    <!-- ./新增帖文按鈕 -->
    <!-- 廣告 -->
    <div class="ad section-group">
      <div class="row">
        <div class="col">
          <ins class="adsbygoogle" style="
                display: inline-block;
                max-width: 300px;
                width: 100%;
                height: 250px;
              " data-ad-client="ca-pub-8370308321819212" data-ad-slot="7350126089"></ins>
        </div>
      </div>
    </div>

    <div id="create-feedpost" class="modal fade" data-backdrop="static" v-if="user != null">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="create-feedpost-title"> {{ $t('Social.CreateFeed.Newpost') }}</div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="feedpost-user">
              <img class="user-logo" :src="user.userLogoBig" :onerror="$defaultUserLog" />
            </div>
            <input class="form-control" type="text" :placeholder="$t('Social.CreateFeed.ShareContent')" v-model="ShareContent" />
          </div>
          <div v-if="showImgUrl != '' || showVideoUrl != ''" class="modal-footer showModalFooter">
            <img v-if="showImgUrl" :src="showImgUrl" width="150" height="150" />
            <video-player ref="stepVideo" v-else class="video-player vjs-custom-skin" :playsinline="true"
              :options="playerOptions"></video-player>
          </div>
          <div class="modal-footer">
            <div class="add-media">
              <el-upload ref="upload" :auto-upload="true" class="upload-demo" :before-upload="imgSaveToUrl"
                :on-success="imgSuccess" :on-error="imgError" :action="uploadUrl" :limit="1" :show-file-list="false">
                <button type="button" class="btn create-post-btn" :title="$t('Social.CreateFeed.uploadUrl')">
                  <i class="fa fa-image"></i>
                </button>
              </el-upload>
            </div>
            <div class="add-media">
              <!-- <el-upload
                ref="upload2"
                :auto-upload="false"
                class="upload-demo"
                :on-change="videoSaveToUrl"
                :action="uploadUrl"
                :limit="1"
                :show-file-list="false"
              > -->
              <button type="button" class="btn create-post-btn" @click="checkIsCert" :title="$t('Social.CreateFeed.Newfilm')">
                <i class="fa fa-video"></i>
              </button>
              <!-- </el-upload> -->
            </div>
            <div v-show="loadingTxt != ''" class="d-flex justify-content-center align-items-center">
              <div class="spinner-border" role="status" v-show="loadingTxt != ''">
                <span class="sr-only"></span>
              </div>
              <span>{{ loadingTxt }}</span>
            </div>
            <div>
              <button type="button" @click="save" class="btn btn-primary">
                 {{ $t('Social.CreateFeed.save') }}
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import base from "../../api/httpApi/base";
import { Message } from "element-ui";
import fileupload from "../../assets/backJs/util";
export default {
  data() {
    return {
      loading: true,
      loadingTxt: "",
      dialogVisible: false,
      uploadUrl: "",
      uploadVideo: null,
      TVModel: null,
      videoForm: null,
      user: null,
      updateError: "",
      showImgUrl: "",
      showVideoUrl: "",
      showImgId: 0,
      showVideoId: 0,
      fileHight: 0,
      fileWidth: 0,
      videoUploadPercent: 0,
      ShareContent: "",
      playerOptions: {
        playbackRates: [0.5, 1, 2, 3], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        poster: "",
        notSupportedMessage: "此視頻暫無法播放，請稍後再試",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      },
    };
  },
  created() {
    this.user = this.$store.getters.getcustomer;
    if (this.user != null) {
      this.uploadUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=moiveCommunity&id=${this.user.userId}`;
    }
  },
  mounted() {
    this.dialogClose();
  },
  methods: {
    checkIsCert() {
      this.closeDialog();
      this.$emit("checkIsCert");
      // //判断是否已认证
      // if (!this.IsNullOrEmpty(this.loginUser) && !this.loginUser.sgL_IsCheck) {
      //   this.closeDialog();
      //   //跳转到认证页面
      //   this.$router.push({
      //     name: "certification",
      //     query: { redirect: this.$route.fullPath },
      //   });
      //   return;
      // } else {
      //   this.$router.push({
      //     name: "SocialVideoUpload",
      //   });
      // }
    },
    dialogClose() {
      let _this = this;
      $("#create-feedpost").on("hide.bs.modal", function () {
        _this.clearData();
      });
    },
    save() {
      let sgL_MoiveTempId = 0;
      let sgL_IsShow = 1;
      let sgL_Type = 2;
      if (this.showImgId != 0) {
        sgL_MoiveTempId = this.showImgId;
        sgL_Type = 1;
      }
      if (this.showVideoId != 0) {
        sgL_MoiveTempId = this.showVideoId;
        sgL_Type = 0;
      }
      if (this.ShareContent == "") {
        Message({
          type: "warning",
          message: "內容不能為空",
        });
        return;
      }
      this.loadingTxt = "發布中";
      this.$emit(
        "saveFeed",
        sgL_MoiveTempId,
        this.ShareContent,
        sgL_Type,
        sgL_IsShow,
        this.fileWidth,
        this.fileHight,
        this.closeDialog
      );
    },
    closeDialog() {
      $("#create-feedpost").modal("hide");
    },
    add() {
      if (this.user == null) {
        this.$router.push({
          path: "/customerLogin",
          query: { redirect: this.$route.fullPath },
        });
        return;
      }
      this.clearData();
      this.ShareContent = "";
      $("#create-feedpost").modal("show");
    },
    clearData() {
      this.showImgId = 0;
      this.showVideoId = 0;
      this.fileHight = 0;
      this.fileWidth = 0;
      this.showImgUrl = "";
      this.showVideoUrl = "";
      this.$refs.upload.clearFiles();
      //this.$refs.upload2.clearFiles();
      this.loadingTxt = "";
    },
    imgSaveToUrl(file) {
      if (["image/jpeg", "image/png"].indexOf(file.type) == -1) {
        Message({
          type: "warning",
          message: "請選擇jpg/png格式",
        });
        return false;
      }
      this.loadingTxt = "上傳中";
    },
    imgError(err, file, fileList) {
      this.loadingTxt = "error:" + err.status;
    },
    imgSuccess(response, file, fileList) {
      this.loadingTxt = "";
      if (response.success) {
        this.$refs.upload.clearFiles();
        this.clearData();
        let test = new Image();
        test.src = window.URL.createObjectURL(file.raw);
        let _this = this;
        test.onload = function () {
          // 打印
          //console.log("width:" + test.width + ",height:" + test.height);
          _this.fileHight = test.height;
          _this.fileWidth = test.width;
        };
        this.showImgUrl = response.result.url;
        this.showImgId = response.result.uploadId;
      } else {
        this.$message({
          type: "error",
          message: response.error.message,
        });
        this.clearData();
      }
    },
    videoSaveToUrl(event) {
      if (this.checkIsCert()) {
        if (
          [
            "video/mp4",
            "video/ogg",
            "video/flv",
            "video/avi",
            "video/wmv",
            "video/rmvb",
            "video/mov",
          ].indexOf(event.raw.type) == -1
        ) {
          Message({
            type: "warning",
            message: "請上傳正確的視頻格式",
          });
          return false;
        }
        this.uploadVideo = event.raw;
        this.getVideoMsg(event.raw).then((res) => {
          // console.log(res);
          // console.log(res.duration);
          // console.log(res.width + "X" + res.height);
          this.fileHight = res.height;
          this.fileWidth = res.width;
        });
        this.submitUpload();
      }
    },
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", function () {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    submitUpload() {
      this.loadingTxt = "上傳中";
      fileupload.uploadFile(
        this.uploadVideo, //视频文件
        this.user.accessToken, //权限token
        this.user.userId,
        (uploadsuccess) => {
          //上传成功的函数
          this.uploadunite(uploadsuccess);
        },
        (successfile) => {
          //this.$refs.upload2.clearFiles();
          let height = 0;
          let width = 0;
          height = this.fileHight;
          width = this.fileWidth;
          this.clearData();
          this.showVideoId = successfile.result.uploadId; //给视频id赋值
          this.playerOptions.sources[0]["src"] = successfile.result.url;
          this.showVideoUrl = successfile.result.url;
          this.fileHight = height;
          this.fileWidth = width;
          this.loadingTxt = "";
        },
        (process) => {
          //进度回调函数
          this.videoUploadPercent = process.toFixed(0) * 1;
        },
        (failePage) => {
          //分片上傳時如果服務斷掉會進入這裏
          Message({
            type: "error",
            message: failePage,
          });
          this.updateError = "，請檢查網絡！";
          //this.$refs.upload2.clearFiles();
        }
      );
      // this.$refs.upload.submit();
    },
    uploadunite(uploadsuccess) {
      this.loadingTxt = "上傳中";
      //合并
      this.$api.VideoApi.uploadfileGather(uploadsuccess)
        .then((res) => {
          if (res.data.success == false) {
            this.isShowUploadVideo = false;
            Message({
              type: "error",
              message: res.data.error.message,
            });
            this.loadingTxt = "合并視頻失敗," + res.data.error.message;
            //this.$refs.upload2.clearFiles();
          } else {
            // Message({
            //   type: "success",
            //   message: "上傳成功",
            // });
            //this.$refs.upload2.clearFiles();
            this.clearData();
            this.showVideoId = res.data.result.uploadId; //给视频id赋值
            this.showVideoUrl = res.data.result.url;
            this.playerOptions.sources[0]["src"] = this.showVideoUrl;
            this.loadingTxt = "";
          }
        })
        .catch((error) => {
          //請求失敗攔截
          if (this.num < 4) {
            setTimeout(() => {
              this.uploadunite(uploadsuccess);
              this.num++;
            }, 30000);
          }
        });
    },
  },
};
</script>

<style scoped>
.create-post-btn {
  color: rgb(0, 0, 0);
  /* color: white; */
}

.btn-primary:focus {
  background-color: #26ad5e;
  border-color: #26ad5e;
}

/* .fx {
  flex: 4;
  width: 100px;
}
.add-media {
  flex: 1;
} */

.modal-footer {
  justify-content: flex-start;
}

.modal-footer div:nth-child(3) {
  flex: 1;
}

.showModalFooter {
  justify-content: space-evenly;
}

.video-player {
  width: 100%;
  height: 100%;
}

.video-player>>>.video-js {
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .div-btn-flex {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 768px) {

  .ad,
  #home.container {
    display: none;
  }
}

.modal .btn {
  margin-left: initial;
}

.user-logo {
  margin-bottom: 10px;
}

.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/CreateFeed.vue